import Module from "./Module.vue";
import detailTraining_DibatalkanCS_TrainingOfflineBasic from "../training-program/belajar-bersama-smartlink/views/detailTraining_DibatalkanCS_TrainingOffline-Basic.vue";
import detailTraining_DibatalkanCS_TrainingOnline from "../training-program/belajar-bersama-smartlink/views/detailTraining_DibatalkanCS_TrainingOnline.vue";
import detailTraining_DijadwalkanUlang_TrainingOfflineBasic from "../training-program/belajar-bersama-smartlink/views/detailTraining_DijadwalkanUlang_TrainingOffline-Basic.vue";
import detailTraining_DijadwalkanUlang_TrainingOnline from "../training-program/belajar-bersama-smartlink/views/detailTraining_DijadwalkanUlang_TrainingOnline.vue";
import detailTraining_FailPembayaran_TrainingOfflineBasic from "../training-program/belajar-bersama-smartlink/views/detailTraining_FailPembayaran_TrainingOffline-Basic.vue";
import detailTraining_FailPembayaran_TrainingOnline from "../training-program/belajar-bersama-smartlink/views/detailTraining_FailPembayaran_TrainingOnline.vue";
import detailTraining_Selesai_TrainingOfflineBasic from "../training-program/belajar-bersama-smartlink/views/detailTraining_Selesai_TrainingOffline-Basic.vue";
import detailTraining_Selesai_TrainingOnline from "../training-program/belajar-bersama-smartlink/views/detailTraining_Selesai_TrainingOnline.vue";
import detailTraining_Terjadwalkan_TrainingOfflineBasic from "../training-program/belajar-bersama-smartlink/views/detailTraining_Terjadwalkan_TrainingOffline-Basic.vue";
import detailTraining_Terjadwalkan_TrainingOnline from "../training-program/belajar-bersama-smartlink/views/detailTraining_Terjadwalkan_TrainingOnline.vue";
import detailTraining_WaitConfirmCS_ResceduleSucses_TrainingOnline from "../training-program/belajar-bersama-smartlink/views/detailTraining_WaitConfirmCS_ResceduleSucses_TrainingOnline.vue";
import detailTraining_WaitConfirmCS_TrainingOfflineBasic from "../training-program/belajar-bersama-smartlink/views/detailTraining_WaitConfirmCS_TrainingOffline-Basic.vue";
import detailTraining_WaitConfirmCS_TrainingOnline from "../training-program/belajar-bersama-smartlink/views/detailTraining_WaitConfirmCS_TrainingOnline.vue";
import detailTraining_WaitPembayaran_TrainingOfflineBasic from "../training-program/belajar-bersama-smartlink/views/detailTraining_WaitPembayaran_TrainingOffline-Basic.vue";
import detailTraining_WaitPembayaran_TrainingOnline from "../training-program/belajar-bersama-smartlink/views/detailTraining_WaitConfirmCS_TrainingOnline.vue";
import detailTrainingSuccess from "../training-program/belajar-bersama-smartlink/views/detailTrainingSuccess.vue";
import infomasiPendaftaran_Bayar_TrainingOfflineAllIn from "../training-program/belajar-bersama-smartlink/views/infomasiPendaftaran_Bayar_TrainingOfflineAll-In.vue";
import infomasiPendaftaran_Bayar_TrainingOfflineBasic from "../training-program/belajar-bersama-smartlink/views/infomasiPendaftaran_Bayar_TrainingOfflineBasic.vue";
import infomasiPendaftaran_Bayar_TrainingOnline from "../training-program/belajar-bersama-smartlink/views/infomasiPendaftaran_Bayar_TrainingOnline.vue";
import informasiPembayaran_Success_TrainingFree from "../training-program/belajar-bersama-smartlink/views/informasiPembayaran_Success_TrainingFree.vue";
import informasiPembayaran_Success_TrainingOfflineAllIn from "../training-program/belajar-bersama-smartlink/views/informasiPembayaran_Success_TrainingOffline-All-In.vue";
import informasiPembayaran_Success_TrainingOfflineBasic from "../training-program/belajar-bersama-smartlink/views/informasiPembayaran_Success_TrainingOffline-Basic.vue";
import informasiPembayaran_Success_TrainingOnline from "../training-program/belajar-bersama-smartlink/views/informasiPembayaran_Success_TrainingOnline.vue";
import informasiPendaftaranSubmit from "../training-program/belajar-bersama-smartlink/views/informasiPendaftaranSubmit.vue";
import pembayaranPilih from "../training-program/belajar-bersama-smartlink/views/pembayaranPilih.vue";
import pembayaranViaBank from "../training-program/belajar-bersama-smartlink/views/pembayaranViaBank.vue";
import pembayaranViaQR from "../training-program/belajar-bersama-smartlink/views/pembayaranViaQR.vue";
import ulasan from "../training-program/belajar-bersama-smartlink/views/ulasan.vue";
import usePromo from "../training-program/belajar-bersama-smartlink/views/usePromo.vue"
import Training from "./belajar-bersama-smartlink/Training.vue";
import PilihProgramFO from "./belajar-bersama-smartlink/views/PilihProgramFO.vue";
import PilihProgramFODone from "./belajar-bersama-smartlink/views/PilihProgramFODone.vue";
import PilihJadwalFO from "./belajar-bersama-smartlink/views/PilihJadwalFO.vue";
import PilihJadwalFODone from "./belajar-bersama-smartlink/views/PilihJadwalFODone.vue";
import PilihProgramPO from "./belajar-bersama-smartlink/views/PilihProgramPO.vue";
import PilihJadwal1PO from "./belajar-bersama-smartlink/views/PilihJadwal1PO.vue";
import PilihJadwal1PODone from "./belajar-bersama-smartlink/views/PilihJadwal1PODone.vue";
import PilihJadwal2PO from "./belajar-bersama-smartlink/views/PilihJadwal2PO.vue";
import PilihJadwal2PODone from "./belajar-bersama-smartlink/views/PilihJadwal2PODone.vue";
import PilihProgramPODone from "./belajar-bersama-smartlink/views/PilihProgramPODone.vue"
import TrainingWithTraining from "./belajar-bersama-smartlink/views/TrainingWithTraining.vue";
import PilihProgramOB from "./belajar-bersama-smartlink/views/PilihProgramOB.vue";
import PilihJadwalOB from "./belajar-bersama-smartlink/views/PilihJadwalOB.vue";
import PilihJadwalOBDone from "./belajar-bersama-smartlink/views/PilihJadwalOBDone.vue";
import PilihProgramOBDone from "./belajar-bersama-smartlink/views/PilihProgramOBDone.vue";
import PilihProgramOAI from "./belajar-bersama-smartlink/views/PilihProgramOAI.vue";
import PilihProgramOAIDone from "./belajar-bersama-smartlink/views/PilihProgramOAIDone.vue";
import PilihJadwalOAI from "./belajar-bersama-smartlink/views/PilihJadwalOAI.vue";
import PilihJadwalOAIDone from "./belajar-bersama-smartlink/views/PilihJadwalOAIDone.vue";
import RiwayatTraining from "./belajar-bersama-smartlink/views/RiwayatTraining.vue";

const requireAuth = { requireAuth: true };

const moduleRoute = {
  path: "/training-program",
  component: Module,
  children: [
    {
      path: "",
      name: "training",
      component: Training,
      meta: requireAuth,
    },
    {
      path: '/pilih-program',
      name: 'pilihProgramFO', 
      component: PilihProgramFO,
      meta: requireAuth,
    },
    {
      path: '/pilih-program-done',
      name: 'pilihProgramFODone', 
      component: PilihProgramFODone,
      meta: requireAuth,
    },
    {
      path: '/pilih-jadwal-fo',
      name: "pilihJadwalFO",
      component: PilihJadwalFO,
      meta: requireAuth,
    },
    {
      path: '/pilih-jadwal-fo-done',
      name: "pilihJadwalFODone",
      component: PilihJadwalFODone,
      meta: requireAuth,
    },
    {
      path: '/pilih-program-po',
      name: "pilihProgramPO",
      component: PilihProgramPO,
      meta: requireAuth,
    },
    {
      path: '/pilih-jadwal-1-po',
      name: "pilihJadwal1PO",
      component: PilihJadwal1PO,
      meta: requireAuth,
    },
    {
      path: '/pilih-jadwal-1-po-done',
      name: "pilihJadwal1PODone",
      component: PilihJadwal1PODone,
      meta: requireAuth,
    },
    {
      path: '/pilih-jadwal-2-po',
      name: "pilihJadwal2PO",
      component: PilihJadwal2PO,
      meta: requireAuth,
    },
    {
      path: '/pilih-jadwal-2-po-done',
      name: "pilihJadwal2PODone",
      component: PilihJadwal2PODone,
      meta: requireAuth,
    },
    {
      path: '/pilih-program-po-done',
      name: "pilihProgramPODone",
      component: PilihProgramPODone,
      meta: requireAuth,
    },
    {
      path: '/pilih-program-ob',
      name: "pilihProgramOB",
      component: PilihProgramOB,
      meta: requireAuth,
    },
    {
      path: '/pilih-jadwal-ob',
      name: "pilihJadwalOB",
      component: PilihJadwalOB,
      meta: requireAuth,
    },
    {
      path: '/pilih-jadwal-ob-done',
      name: "pilihJadwalOBDone",
      component: PilihJadwalOBDone,
      meta: requireAuth,
    },
    {
      path: '/pilih-program-ob-done',
      name: "pilihProgramOBDone",
      component: PilihProgramOBDone,
      meta: requireAuth,
    },
    {
      path: '/pilih-program-oai',
      name: "pilihProgramOAI",
      component: PilihProgramOAI,
      meta: requireAuth,
    },
    {
      path: '/pilih-program-oai-done',
      name: "pilihProgramOAIDone",
      component: PilihProgramOAIDone,
      meta: requireAuth,
    },
    {
      path: '/pilih-jadwal-oai',
      name: "pilihJadwalOAI",
      component: PilihJadwalOAI,
      meta: requireAuth,
    },
    {
      path: '/pilih-jadwal-oai-done',
      name: "pilihJadwalOAIDone",
      component: PilihJadwalOAIDone,
      meta: requireAuth,
    },
    {
      path: '/training-with-training',
      name: "trainingWithTraining",
      component: TrainingWithTraining,
      meta: requireAuth,
    },
    {
      path: '/riwayat-training',
      name: "riwayatTraining",
      component: RiwayatTraining,
      meta: requireAuth,
    },
   {
      path: "/detailTraining_DibatalkanCS_TrainingOfflineBasic",
      name: "detailTraining_DibatalkanCS_TrainingOfflineBasic",
      component: detailTraining_DibatalkanCS_TrainingOfflineBasic,
      meta: requireAuth,
    },
    {
      path: "/detailTraining_DibatalkanCS_TrainingOnline",
      name: "detailTraining_DibatalkanCS_TrainingOnline",
      component: detailTraining_DibatalkanCS_TrainingOnline,
      meta: requireAuth,
    },
    {
      path: "/detailTraining_DijadwalkanUlang_TrainingOfflineBasic",
      name: "detailTraining_DijadwalkanUlang_TrainingOfflineBasic",
      component: detailTraining_DijadwalkanUlang_TrainingOfflineBasic,
      meta: requireAuth,
    },
    {
      path: "/detailTraining_DijadwalkanUlang_TrainingOnline",
      name: "detailTraining_DijadwalkanUlang_TrainingOnline",
      component: detailTraining_DijadwalkanUlang_TrainingOnline,
      meta: requireAuth,
    },
    {
      path: "/detailTraining_FailPembayaran_TrainingOfflineBasic",
      name: "detailTraining_FailPembayaran_TrainingOfflineBasic",
      component: detailTraining_FailPembayaran_TrainingOfflineBasic,
      meta: requireAuth,
    },
    {
      path: "/detailTraining_FailPembayaran_TrainingOnline",
      name: "detailTraining_FailPembayaran_TrainingOnline",
      component: detailTraining_FailPembayaran_TrainingOnline,
      meta: requireAuth,
    },
    {
      path: "/detailTraining_Selesai_TrainingOfflineBasic",
      name: "detailTraining_Selesai_TrainingOfflineBasic",
      component: detailTraining_Selesai_TrainingOfflineBasic,
      meta: requireAuth,
    },
    {
      path: "/detailTraining_Selesai_TrainingOnline",
      name: "detailTraining_Selesai_TrainingOnline",
      component: detailTraining_Selesai_TrainingOnline,
      meta: requireAuth,
    },
    {
      path: "/detailTraining_Terjadwalkan_TrainingOfflineBasic",
      name: "detailTraining_Terjadwalkan_TrainingOfflineBasic",
      component: detailTraining_Terjadwalkan_TrainingOfflineBasic,
      meta: requireAuth,
    },
    {
      path: "/detailTraining_Terjadwalkan_TrainingOnline",
      name: "detailTraining_Terjadwalkan_TrainingOnline",
      component: detailTraining_Terjadwalkan_TrainingOnline,
      meta: requireAuth,
    },
    {
      path: "/detailTraining_WaitConfirmCS_ResceduleSucses_TrainingOnline",
      name: "detailTraining_WaitConfirmCS_ResceduleSucses_TrainingOnline",
      component: detailTraining_WaitConfirmCS_ResceduleSucses_TrainingOnline,
      meta: requireAuth,
    },
    {
      path: "/detailTraining_WaitConfirmCS_TrainingOfflineBasic",
      name: "detailTraining_WaitConfirmCS_TrainingOfflineBasic",
      component: detailTraining_WaitConfirmCS_TrainingOfflineBasic,
      meta: requireAuth,
    },
    {
      path: "/detailTraining_WaitConfirmCS_TrainingOnline",
      name: "detailTraining_WaitConfirmCS_TrainingOnline",
      component: detailTraining_WaitConfirmCS_TrainingOnline,
      meta: requireAuth,
    },
    {
      path: "/detailTraining_WaitPembayaran_TrainingOfflineBasic",
      name: "detailTraining_WaitPembayaran_TrainingOfflineBasic",
      component: detailTraining_WaitPembayaran_TrainingOfflineBasic,
      meta: requireAuth,
    },
    {
      path: "/detailTraining_WaitPembayaran_TrainingOnline",
      name: "detailTraining_WaitPembayaran_TrainingOnline",
      component: detailTraining_WaitPembayaran_TrainingOnline,
      meta: requireAuth,
    },
    {
      path: "/detailTrainingSuccess",
      name: "detailTrainingSuccess",
      component: detailTrainingSuccess,
      meta: requireAuth,
    },
    {
      path: "/infomasiPendaftaran_Bayar_TrainingOfflineAllIn",
      name: "infomasiPendaftaran_Bayar_TrainingOfflineAllIn",
      component: infomasiPendaftaran_Bayar_TrainingOfflineAllIn,
      meta: requireAuth,
    },
    {
      path: "/infomasiPendaftaran_Bayar_TrainingOfflineBasic",
      name: "infomasiPendaftaran_Bayar_TrainingOfflineBasic",
      component: infomasiPendaftaran_Bayar_TrainingOfflineBasic,
      meta: requireAuth,
    },
    {
      path: "/infomasiPendaftaran_Bayar_TrainingOnline",
      name: "infomasiPendaftaran_Bayar_TrainingOnline",
      component: infomasiPendaftaran_Bayar_TrainingOnline,
      meta: requireAuth,
    },
    {
      path: "/informasiPembayaran_Success_TrainingFree",
      name: "informasiPembayaran_Success_TrainingFree",
      component: informasiPembayaran_Success_TrainingFree,
      meta: requireAuth,
    },
    {
      path: "/informasiPembayaran_Success_TrainingOfflineAllIn",
      name: "informasiPembayaran_Success_TrainingOfflineAllIn",
      component: informasiPembayaran_Success_TrainingOfflineAllIn,
      meta: requireAuth,
    },
    {
      path: "/informasiPembayaran_Success_TrainingOfflineBasic",
      name: "informasiPembayaran_Success_TrainingOfflineBasic",
      component: informasiPembayaran_Success_TrainingOfflineBasic,
      meta: requireAuth,
    },
    {
      path: "/informasiPembayaran_Success_TrainingOnline",
      name: "informasiPembayaran_Success_TrainingOnline",
      component: informasiPembayaran_Success_TrainingOnline,
      meta: requireAuth,
    },
    {
      path: "/informasiPendaftaranSubmit",
      name: "informasiPendaftaranSubmit",
      component: informasiPendaftaranSubmit,
      meta: requireAuth,
    },
    {
      path: "/pembayaranPilih",
      name: "pembayaranPilih",
      component: pembayaranPilih,
      meta: requireAuth,
    },
    {
      path: "/pembayaranViaBank",
      name: "pembayaranViaBank",
      component: pembayaranViaBank,
      meta: requireAuth,
    },
    {
      path: "/pembayaranViaQR",
      name: "pembayaranViaQR",
      component: pembayaranViaQR,
      meta: requireAuth,
    },
    {
      path: "/ulasan",
      name: "ulasan",
      component: ulasan,
      meta: requireAuth,
    },
    {
      path: "/usePromo",
      name: "usePromo",
      component: usePromo,
      meta: requireAuth,
    },
  ]
};

export default (router) => {
  router.addRoutes([moduleRoute]);
};
